<template>
    <DataSortFilter v-bind="$attrs" :model-value="modelValue" :label="label" :options="options" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import DataSortFilter from "@/components/DataSortFilter.vue";
import { defaultCampaignSortBy } from "@/enums/sort";

export default defineComponent({
    name: "SortCampaigns",
    components: { DataSortFilter },
    inheritAttrs: false,
    props: {
        modelValue: {
            type: String,
            default: defaultCampaignSortBy
        }
    },
    data() {
        return {
            options: [
                {
                    field: "Name",
                    ascValue: "name_ASC",
                    ascOptionDirection: "A to Z",
                    descValue: "name_DESC",
                    descOptionDirection: "Z to A"
                }
            ],
            label: "Sort by:"
        };
    }
});
</script>
